class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.notification.addEventListener('click', this.handleQuantityClick.bind(this));
    this.parseState = {};
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.parseState = parsedState;
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  async fetchCartData() {
    const response = await fetch('/cart.json');
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }
    const data = await response.json();
    return data;
  }

  handleQuantityClick(evt) {
    const target = evt.target;
    if (target.matches('.plus-icon') || target.matches('.icon-minus')) {
      const quantityInput = target.closest('.quantity');
      const input = quantityInput.querySelector('.quantity__input');
      // const change = target.matches('.plus-icon') ? 1 : -1;

      let newQuantity = parseInt(input.value);
      newQuantity = newQuantity < 1 ? 1 : newQuantity; // Prevent quantity from going below 1
      input.value = newQuantity;
      this.updateCartQuantity(input.id, newQuantity, target);
      const qty_box = document.querySelector('.quantity-container .quantity');
      qty_box.style.pointerEvents = 'none';
    }

    if (target.matches('.cart-remove-button-notification') || target.matches('.icon-remove')) {
      const buttonElement = document.querySelector('.cart-remove-button-notification');

      // Get the value of the data-variant-id attribute
      const variantId = buttonElement.getAttribute('data-variant-id');
      this.removeCartItem(variantId);
    }
  }

  async removeCartItem(variantId) {
    const updates = {};
    updates[variantId] = 0;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      const data = await response.json();
      if (data) {
        const cartData = await this.fetchCartData();
        const cart_item_count = cartData.item_count;

        const cartCountSpan = document.querySelector('.cart-count-bubble');
        const cartNotificationButton = document.querySelector('#cart-notification-button');
        cartCountSpan.innerHTML = `<span aria-hidden="true">&nbsp;(${cart_item_count})</span><span class="visually-hidden">&nbsp;${cart_item_count} items</span>`;
        cartNotificationButton.innerHTML = `View cart (${cart_item_count})`;
        this.close();
      }
    } catch (error) {
      console.error('Failed to update cart quantity:', error);
    }
  }

  async updateCartQuantity(variantId, quantity, target) {
    const updates = {};
    const variantItemId = variantId.replace('Quantity-', '')
    updates[variantItemId] = quantity;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      const data = await response.json();
      if (data) {
        const cartData = await this.fetchCartData();
        const item_price = cartData.items.filter(item => item.id == variantItemId)[0].original_line_price;
        const cart_item_count = cartData.item_count;
        const currency = cartData.currency;

        const cartCountSpan = document.querySelector('.cart-count-bubble');
        const cartNotificationButton = document.querySelector('#cart-notification-button');
        cartCountSpan.innerHTML = `<span aria-hidden="true">&nbsp;(${cart_item_count})</span><span class="visually-hidden">&nbsp;${cart_item_count} items</span>`;
        cartNotificationButton.innerHTML = `View cart (${cart_item_count})`;
        document.querySelector('.cart-notification-product__info-subtotal .product-item-price').innerHTML = this.formatPrice(item_price, currency);

        let notificationMsgElement = document.querySelector('.item_notification_msg');
        if (target.matches('.plus-icon')) {
          notificationMsgElement.innerHTML = '1 Item added to bag';
        } else {
          notificationMsgElement.innerHTML = '1 Item removed from bag';
        }

        const qty_box_updated = document.querySelector('.quantity-container .quantity');
        qty_box_updated.style.pointerEvents = 'auto';
      }
    } catch (error) {
      console.error('Failed to update cart quantity:', error);
    }
  }

  formatPrice(price, currency) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(price / 100);
  }

  /**
   * Show a custom notification with a list of items (e.g., bundle items)
   * @param {Array} items - Array of cart item objects to display
   * @param {String} [message] - Optional notification message
   */
  showCustomItems(items, message = 'Bundle added to cart!') {
    // Build HTML for each item (similar to cart-notification-product.liquid)
    const itemsHtml = items.map(item => {
      // Discount title(s)
      let discountHtml = '';
      if (item.discounts && Array.isArray(item.discounts) && item.discounts.length > 0) {
        discountHtml = `
          <ul class="discounts list-unstyled" role="list" aria-label="Discount">
            <li class="discounts__discount">
              <svg aria-hidden="true" focusable="false" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd"d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg>
              <span>${item.discounts.map(d => d.title).join(', ')}</span>
            </li>
          </ul>
        `;
      }
      // Price display: original (strikethrough if discounted) and final
      let priceHtml = '';
      if (item.original_line_price && item.final_line_price && item.original_line_price !== item.final_line_price) {
        priceHtml = `<span class="product-item-price product-item-price--original" style="text-decoration: line-through; color: #888; margin-right: 0.5em;">${this.formatPrice(item.original_line_price, item.currency || 'USD')}</span>`;
        priceHtml += `<span class="product-item-price product-item-price--final">${this.formatPrice(item.final_line_price, item.currency || 'USD')}</span>`;
      } else if (item.final_line_price) {
        priceHtml = `<span class="product-item-price product-item-price--final">${this.formatPrice(item.final_line_price, item.currency || 'USD')}</span>`;
      }
      return `
        <div class="cart-item">
          ${item.image ? `<div class="cart-notification-product__image global-media-settings">
            <img src="${item.image}" alt="${item.product_title}" width="100" height="100" loading="lazy">
          </div>` : ''}
          <div class="cart-notification-item" data-quantity-variant-id="${item.variant_id}">
            <div class="cart-notification-product__info-wrapper">
              <div class="cart-notification-product__info-main">
                <div class="product-title-wrapper">
                  <h3 class="cart-notification-product__name h4">${item.product_title}</h3>
                </div>
                <div class="product-option-price">${item.final_line_price ? this.formatPrice(item.final_line_price, item.currency || 'USD') : (item.price ? this.formatPrice(item.price, item.currency || 'USD') : '')}</div>
                ${item.options_with_values ? item.options_with_values.map(option => `
                  <div class="product-option" data-option-name="${option.name}">
                    <dt>${option.name}:</dt>
                    <dd>${option.value}</dd>
                  </div>`).join('') : ''}
              </div>
              <div class="cart-notification-product__info-subtotal">
                ${priceHtml}
              </div>
            </div>
            ${discountHtml}
            <div class="quantity-container visually-hidden">
              <quantity-input class="quantity">
                <button class="quantity__button no-js-hidden icon-minus" name="minus" type="button">
                  <!-- icon-minus -->
                  <svg class="icon icon-minus" aria-hidden="true" focusable="false">
                    <path d="M20 13H4V11H20V13Z" fill="currentColor"></path>
                  </svg>
                </button>
                <input
                  class="quantity__input"
                  type="number"
                  name="quantity"
                  id="Quantity-${item.variant_id}"
                  step="1"
                  value="${item.quantity || 1}"
                />
                <button class="quantity__button no-js-hidden plus-icon" name="plus" type="button">
                  <!-- icon-plus -->
                  <svg class="icon icon-plus" aria-hidden="true" focusable="false">
                    <path d="M20 13.1429H13.1429V20H10.8571V13.1429H4V10.8571H10.8571V4H13.1429V10.8571H20V13.1429Z" fill="currentColor"></path>
                  </svg>
                </button>
              </quantity-input>
              <cart-remove-button id="CartNotification-Remove">
                <button
                  type="button"
                  class="button button--tertiary cart-remove-button-notification"
                  aria-label="Remove ${item.product_title}"
                  data-variant-id="${item.variant_id}"
                >
                  <svg class="icon icon-remove" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 5.99991H16V4.32991C15.9765 3.68973 15.7002 3.08497 15.2316 2.64821C14.7629 2.21144 14.1402 1.97831 13.5 1.99991H10.5C9.85975 1.97831 9.23706 2.21144 8.76843 2.64821C8.2998 3.08497 8.02346 3.68973 8 4.32991V5.99991H3C2.73478 5.99991 2.48043 6.10527 2.29289 6.29281C2.10536 6.48034 2 6.7347 2 6.99991C2 7.26513 2.10536 7.51948 2.29289 7.70702C2.48043 7.89456 2.73478 7.99991 3 7.99991H4V18.9999C4 19.7956 4.31607 20.5586 4.87868 21.1212C5.44129 21.6838 6.20435 21.9999 7 21.9999H17C17.7956 21.9999 18.5587 21.6838 19.1213 21.1212C19.6839 20.5586 20 19.7956 20 18.9999V7.99991H21C21.2652 7.99991 21.5196 7.89456 21.7071 7.70702C21.8946 7.51948 22 7.26513 22 6.99991C22 6.7347 21.8946 6.48034 21.7071 6.29281C21.5196 6.10527 21.2652 5.99991 21 5.99991ZM10 4.32991C10 4.16991 10.21 3.99991 10.5 3.99991H13.5C13.79 3.99991 14 4.16991 14 4.32991V5.99991H10V4.32991ZM18 18.9999C18 19.2651 17.8946 19.5195 17.7071 19.707C17.5196 19.8946 17.2652 19.9999 17 19.9999H7C6.73478 19.9999 6.48043 19.8946 6.29289 19.707C6.10536 19.5195 6 19.2651 6 18.9999V7.99991H18V18.9999Z" fill="currentColor"/>
                    <path d="M9 17C9.26522 17 9.51957 16.8946 9.70711 16.7071C9.89464 16.5196 10 16.2652 10 16V12C10 11.7348 9.89464 11.4804 9.70711 11.2929C9.51957 11.1054 9.26522 11 9 11C8.73478 11 8.48043 11.1054 8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12V16C8 16.2652 8.10536 16.5196 8.29289 16.7071C8.48043 16.8946 8.73478 17 9 17Z" fill="currentColor"/>
                    <path d="M15 17C15.2652 17 15.5196 16.8946 15.7071 16.7071C15.8946 16.5196 16 16.2652 16 16V12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11C14.7348 11 14.4804 11.1054 14.2929 11.2929C14.1054 11.4804 14 11.7348 14 12V16C14 16.2652 14.1054 16.5196 14.2929 16.7071C14.4804 16.8946 14.7348 17 15 17Z" fill="currentColor"/>
                  </svg>
                </button>
              </cart-remove-button>
            </div>
          </div>
        </div>
      `;
    }).join('');
    // Wrap all items in a bundle container
    const bundleHtml = `<div class="cart-notification-bundle-product">${itemsHtml}</div>`;
    // Insert into notification
    const productContainer = document.getElementById('cart-notification-product');
    if (productContainer) productContainer.innerHTML = bundleHtml;
    // Set custom message
    const msgEl = document.querySelector('.item_notification_msg');
    if (msgEl) msgEl.textContent = message;
    // Show notification
    this.open();
  }
}

customElements.define('cart-notification', CartNotification);
